export default __webpack_public_path__ + "static/weboffon-f567d60393be200932259db8389c004f.jpg";